import { TRPCClientError } from "@trpc/client";
import { CustomError } from "./ErrorManager";
import { ApiError, NetworkError } from "@/frontend/@api/apiBase";

class TRPCError extends Error {
    data: {
        code: "FORBIDDEN" | "BAD_REQUEST"; // ideally would be getting error codes from trpc package
    } = { code: "BAD_REQUEST" };
}
export function isTRPCError(error: Error): error is TRPCError {
    return (
        error instanceof TRPCClientError &&
        "data" in error &&
        typeof error.data === "object" &&
        error.data !== null &&
        "code" in error.data
    );
}

export function isPermissionDenied(error: Error): boolean {
    return (
        (error instanceof ApiError && error.isPermissionDenied()) ||
        (isTRPCError(error) && error.data.code === "FORBIDDEN")
    );
}

export function isInvalidOrExpiredToken(error: Error): boolean {
    return (
        ((error instanceof ApiError && error.isInvalidOrExpiredToken()) ||
            (error instanceof TRPCClientError &&
                error.meta &&
                "response" in error.meta &&
                (error.meta["response"] as Response).status === 401)) ??
        false
    );
}

export function isNetworkError(error: Error): boolean {
    return (
        error instanceof NetworkError ||
        (error instanceof TRPCClientError &&
            error.message === "Failed to fetch")
    );
}

export function isCustomError(error: Error): error is CustomError {
    return error instanceof CustomError;
}
